import React, { useState, useEffect } from 'react';
import PocketBase from 'pocketbase';

const pb = new PocketBase('https://bahcarplaza.com');
const CITIES = ['Kolkata', 'Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Pune', 'Hyderabad', 'Ahmedabad', 'Jaipur'];
const STATES = [
  "Andhra Pradesh", "Assam", "Bihar", "Delhi", "Gujarat", "Karnataka", "Maharashtra", "West Bengal"
]; 

// 🚨 Added goBack prop 🚨
function MobileAccount({ view, setView, activeTab, setActiveTab, setSelectedCar, goBack }) {
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [cameFromDashboard, setCameFromDashboard] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const isAdmin = pb.authStore.isValid && ['nabojyoti46@gmail.com', 'admin@test.com'].includes(pb.authStore.model?.email);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 🚨 HARDWARE BACK BUTTON INTERCEPTOR 🚨
  useEffect(() => {
    const handlePopState = (event) => {
      // If we are INSIDE a tab (Menu is closed) and user presses hardware back
      if (!isMenuOpen) {
        if (cameFromDashboard) {
          setView('dashboard');
          setCameFromDashboard(false);
        } else {
          setIsMenuOpen(true); // Open the main menu instead of leaving the page
          // Push state back so we don't actually leave the account page
          window.history.pushState({ page: 'account', menuOpen: true }, '');
        }
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [isMenuOpen, cameFromDashboard, setView]);

  useEffect(() => {
    const handleOpenMenu = () => setIsMenuOpen(true);
    const handleCloseMenu = () => { 
      setIsMenuOpen(false);
      setCameFromDashboard(true); 
      // Push state when entering a tab from dashboard
      window.history.pushState({ page: 'account', tab: activeTab }, '');
    }; 
    
    window.addEventListener('openAccountMenu', handleOpenMenu);
    window.addEventListener('closeAccountMenu', handleCloseMenu); 
    
    return () => {
      window.removeEventListener('openAccountMenu', handleOpenMenu);
      window.removeEventListener('closeAccountMenu', handleCloseMenu); 
    };
  }, [activeTab]);

  const [myOrders, setMyOrders] = useState([]); 
  const [favCars, setFavCars] = useState([]); 
  const [myBookings, setMyBookings] = useState([]);
  const [userData, setUserData] = useState(pb.authStore.model || {});

  const [profileImage, setProfileImage] = useState(null); 
  const [profileData, setProfileData] = useState({ name: '', phone: '', city: '' });
  const [addressData, setAddressData] = useState({ address_line: '', landmark: '', city: '', state: '', pin_code: '' });

  const [rechargeAmount, setRechargeAmount] = useState('');
  const [isRecharging, setIsRecharging] = useState(false);

  const fetchAccountData = async () => {
    try {
      const uid = pb.authStore.model?.id;
      if (!uid) return;

      const [ords, wish, books, user] = await Promise.all([
        pb.collection('orders').getFullList({ filter: `user_id = "${uid}"`, expand: 'car_id', sort: '-created' }),
        pb.collection('wishlist').getFullList({ filter: `user_id = "${uid}"`, expand: 'car_id' }),
        pb.collection('bookings').getFullList({ filter: `user_id = "${uid}"`, expand: 'car_id', sort: '-created' }),
        pb.collection('users').getOne(uid)
      ]);
      
      setMyOrders(ords); setFavCars(wish); setMyBookings(books); setUserData(user);
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    if (!pb.authStore.isValid) { setView('auth'); return; }
    fetchAccountData();
  }, [activeTab]); 

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (activeTab === 'Profile Update') {
      setProfileData({ name: userData.name || '', phone: userData.phone || '', city: userData.city || '' });
    }
    if (activeTab === 'My Address') {
      setAddressData({
        address_line: userData.address_line || '', landmark: userData.landmark || '',
        city: userData.city || '', state: userData.state || '', pin_code: userData.pin_code || ''
      });
    }
  }, [activeTab, userData]);

  const getVal = (val) => (Array.isArray(val) ? val[0] : val || "");

  const calculateProfileScore = () => {
    if (!userData) return 0;
    let score = 0;
    if (userData.name) score += 20;
    if (userData.phone) score += 20;
    if (userData.avatar) score += 20;
    if (userData.city) score += 20;
    if (userData.address_line && userData.pin_code) score += 20;
    return score;
  };
  const profileScore = calculateProfileScore();

  // 🚨 REMOVED 'My Ad' from MENU_ITEMS 🚨
  const MENU_ITEMS = [
    { name: 'Profile Update', icon: '👤', badge: profileScore === 100 ? '100% Complete' : `${profileScore}% Complete`, badgeColor: profileScore === 100 ? 'bg-[#e1f9eb] text-[#1db954]' : 'bg-[#fff4e6] text-[#ef5e33]' },
    { name: 'My Orders', icon: '📦', badge: myOrders.length > 0 ? `${myOrders.length} Orders` : null, badgeColor: 'bg-[#e3f2fd] text-[#1a73e8]' },
    { name: 'My Bookings', icon: '🗓️', badge: myBookings.length > 0 ? `${myBookings.length} Bookings` : null, badgeColor: 'bg-[#e3f2fd] text-[#1a73e8]' },
    { name: 'Wallet', icon: '💳', badge: `₹${(userData?.wallet_balance || 0).toLocaleString()}`, badgeColor: 'bg-[#e1f9eb] text-[#1db954]' },
    { name: 'My Address', icon: '📍', badge: userData?.address_line ? 'Linked' : 'Pending', badgeColor: userData?.address_line ? 'bg-[#e1f9eb] text-[#1db954]' : 'bg-[#ffebeb] text-[#dc3545]' },
    { name: 'Wishlist', icon: '❤️', badge: favCars.length > 0 ? `${favCars.length} Cars` : null, badgeColor: 'bg-[#ffebeb] text-[#dc3545]' },
    { name: 'Analytics', icon: '📊', badge: null, badgeColor: '' },
  ];

  const handleMenuClick = (tabName) => {
    setActiveTab(tabName);
    setIsMenuOpen(false);
    // 🚨 Push state to history when opening a tab 🚨
    window.history.pushState({ page: 'account', tab: tabName }, '');
    window.scrollTo(0, 0); 
  };

  const handleCustomBack = () => {
    if (cameFromDashboard) {
      setView('dashboard');
      setCameFromDashboard(false);
    } else {
      setIsMenuOpen(true);
      window.history.back(); // Trigger popstate to maintain sync
    }
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      pb.authStore.clear(); setView('home'); window.location.reload();
    }
  };

  const deleteRecord = async (collection, id) => {
    if (window.confirm("Are you sure you want to delete this?")) {
      try { await pb.collection(collection).delete(id); fetchAccountData(); } 
      catch (e) { alert("Delete failed: " + e.message); }
    }
  };

  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    try { 
      const formData = new FormData();
      formData.append('name', profileData.name); formData.append('phone', profileData.phone); formData.append('city', profileData.city);
      if (profileImage) formData.append('avatar', profileImage); 
      
      await pb.collection('users').update(pb.authStore.model.id, formData); 
      const updatedUser = await pb.collection('users').getOne(pb.authStore.model.id);
      pb.authStore.save(pb.authStore.token, updatedUser);

      alert("Profile updated successfully!"); setProfileImage(null); fetchAccountData(); 
    } catch (e) { alert("Update failed: " + e.message); }
  };

  const handleAddressUpdate = async (e) => {
    e.preventDefault();
    try {
      await pb.collection('users').update(pb.authStore.model.id, addressData);
      const updatedUser = await pb.collection('users').getOne(pb.authStore.model.id);
      pb.authStore.save(pb.authStore.token, updatedUser);

      alert("Address saved successfully!"); fetchAccountData();
    } catch (e) { alert("Failed to save address: " + e.message); }
  };

  const handleWalletRecharge = async () => {
    const amount = Number(rechargeAmount);
    if (!amount || amount <= 0) return alert("Please enter a valid amount.");
    setIsRecharging(true);
    try {
      const response = await fetch('https://bahcarplaza.com/payment/api/razorpay/create-order', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: amount, receiptId: `wallet_${pb.authStore.model.id}_${Date.now()}` })
      });
      const data = await response.json();
      if (!data.success) { alert("Payment Failed!"); setIsRecharging(false); return; }

      const options = {
        key: data.keyId, amount: data.order.amount, currency: "INR", name: "Bah! Car Plaza", description: "Wallet Recharge",
        order_id: data.order.id, 
        handler: async function (response) {
          try {
            const newBalance = (userData.wallet_balance || 0) + amount;
            await pb.collection('users').update(pb.authStore.model.id, { wallet_balance: newBalance });
            const updatedUser = await pb.collection('users').getOne(pb.authStore.model.id);
            pb.authStore.save(pb.authStore.token, updatedUser); setUserData(updatedUser);
            setRechargeAmount(''); alert(`🎉 Success! ₹${amount.toLocaleString()} added to your wallet.`);
          } catch (e) { alert("Payment successful but failed to update wallet."); }
          setIsRecharging(false);
        },
        prefill: { name: userData?.name || "", email: userData?.email || "", contact: userData?.phone || "" },
        theme: { color: "#002f34" }, modal: { ondismiss: function() { setIsRecharging(false); } }
      };
      const razorpayObject = new window.Razorpay(options);
      razorpayObject.on('payment.failed', function () { alert("❌ Payment Failed."); setIsRecharging(false); });
      razorpayObject.open();
    } catch (error) { alert("Server Error!"); setIsRecharging(false); }
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    const names = name.split(' ');
    if (names.length >= 2) return (names[0][0] + names[1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
  };

  const inputStyle = { padding: '12px 15px', borderRadius: '12px', border: '1px solid #ddd', backgroundColor: '#f9f9f9', fontWeight: 'bold', width: '100%', fontSize: '13px', outline: 'none' };

  // ==========================================
  // 🚨 DETAILS VIEW (Inner Tabs) 🚨
  // ==========================================
  if (!isMenuOpen) {
    return (
      <div className="min-h-screen bg-[#f4f7f6] pb-[80px] flex flex-col font-sans">
        
        {/* Animated Deep Blue Header for Details Pages */}
        <div className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#012b72] shadow-md py-3' : 'bg-[#012b72] pt-4 pb-4 shadow-none rounded-b-[1.5rem]'}`}>
          <div className="px-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              
              {/* 🚨 Custom Back Button 🚨 */}
              <button onClick={handleCustomBack} className="bg-white/20 w-8 h-8 rounded-full border-none text-white text-lg flex items-center justify-center font-bold cursor-pointer hover:bg-white/30 transition-colors">
                ←
              </button>

              <h2 className={`m-0 font-black text-[16px] text-white uppercase tracking-wide transition-opacity duration-300`}>{activeTab}</h2>
            </div>
            
            <div className={`transition-opacity duration-300 ${isScrolled ? 'opacity-0' : 'opacity-100'}`}>
               <span className="text-white/80 text-xl">
                 {MENU_ITEMS.find(i => i.name === activeTab)?.icon || '⚙️'}
               </span>
            </div>
          </div>
        </div>

        {/* Spacer for Header */}
        <div className={`transition-all duration-300 ${isScrolled ? 'h-[60px]' : 'h-[80px]'}`}></div>
        
        <div className="p-4 flex-1">
           {/* 1. MY BOOKINGS */}
           {activeTab === 'My Bookings' && (
             <div className="flex flex-col gap-4">
               {myBookings.length > 0 ? myBookings.map(b => (
                 <div key={b.id} className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100 flex gap-3 relative">
                   <img src={b.expand?.car_id?.image ? `https://bahcarplaza.com/api/files/${b.expand.car_id.collectionId}/${b.car_id}/${getVal(b.expand.car_id.image)}` : ''} onClick={() => { setSelectedCar(b.expand?.car_id); setView('details'); }} className="w-[100px] h-[75px] rounded-xl object-cover cursor-pointer" alt="car" />
                   <div className="flex-1">
                     <h3 className="text-[#002f34] font-black text-[15px] m-0 uppercase line-clamp-1">{b.expand?.car_id?.brand} {b.expand?.car_id?.model}</h3>
                     <p className="text-gray-500 font-bold text-[10px] m-0 mt-1">🗓️ {new Date(b.booking_date).toLocaleDateString()}</p>
                     <p className="text-gray-500 font-bold text-[10px] m-0">🏷️ {b.visit_type}</p>
                     <span className={`absolute top-3 right-3 text-[9px] font-black px-2 py-1 rounded-md uppercase ${b.status === 'Confirmed' ? 'bg-[#1db954] text-white' : 'bg-gray-100 text-gray-600'}`}>{b.status}</span>
                   </div>
                 </div>
               )) : <p className="text-center text-gray-400 font-bold mt-10">No bookings found.</p>}
             </div>
           )}

           {/* 2. MY ORDERS */}
           {activeTab === 'My Orders' && (
             <div className="flex flex-col gap-4">
               {myOrders.length > 0 ? myOrders.map(o => (
                 <div key={o.id} className="bg-white p-4 rounded-2xl shadow-sm border border-gray-100">
                   <div className="flex gap-3 mb-3 border-b border-gray-50 pb-3">
                     <img src={o.expand?.car_id?.image ? `https://bahcarplaza.com/api/files/${o.expand.car_id.collectionId}/${o.car_id}/${getVal(o.expand.car_id.image)}` : ''} onClick={() => { setSelectedCar(o.expand?.car_id); setView('details'); }} className="w-[100px] h-[70px] rounded-xl object-cover cursor-pointer" alt="car" />
                     <div>
                       <h4 className="text-[#002f34] font-black text-[14px] m-0 uppercase line-clamp-2">{o.expand?.car_id?.brand} {o.expand?.car_id?.model}</h4>
                       <p className="text-gray-400 font-bold text-[10px] m-0 mt-1">#{o.id.slice(0,8)}</p>
                     </div>
                   </div>
                   <div className="flex justify-between items-center">
                     <h3 className="text-[#ef5e33] font-black text-[18px] m-0">₹{o.amount?.toLocaleString()}</h3>
                     <span className={`text-[10px] font-black px-3 py-1.5 rounded-lg uppercase text-white ${o.payment_status === 'Processing' || o.payment_status === 'Delivered' ? 'bg-[#1db954]' : o.payment_status === 'Failed' ? 'bg-[#dc3545]' : 'bg-[#f39c12]'}`}>{o.payment_status}</span>
                   </div>
                 </div>
               )) : <p className="text-center text-gray-400 font-bold mt-10">No orders found.</p>}
             </div>
           )}

           {/* 3. WISHLIST */}
           {activeTab === 'Wishlist' && (
             <div className="grid grid-cols-2 gap-3">
               {favCars.length > 0 ? favCars.map(fav => {
                 const car = fav.expand?.car_id; if(!car) return null;
                 return (
                   <div key={fav.id} className="bg-white p-2 rounded-2xl shadow-sm border border-gray-100 relative">
                     <img src={`https://bahcarplaza.com/api/files/${car.collectionId}/${car.id}/${getVal(car.image)}`} onClick={() => { setSelectedCar(car); setView('details'); }} className="w-full h-[100px] rounded-xl object-cover mb-2 cursor-pointer" alt="car" />
                     <button onClick={() => deleteRecord('wishlist', fav.id)} className="absolute top-3 right-3 bg-white text-red-500 w-6 h-6 rounded-full flex items-center justify-center shadow-md border-none text-xs cursor-pointer">🗑</button>
                     <h4 className="text-[#002f34] font-black text-[12px] uppercase truncate m-0">{car.brand} {car.model}</h4>
                     <p className="text-[#ef5e33] font-black text-[14px] m-0 mt-1">₹{car.price?.toLocaleString()}</p>
                   </div>
                 );
               }) : <p className="text-center text-gray-400 font-bold mt-10 col-span-2">Your wishlist is empty.</p>}
             </div>
           )}

           {/* 4. WALLET */}
           {activeTab === 'Wallet' && (
             <div className="bg-gradient-to-br from-[#012b72] to-[#001740] rounded-[30px] p-6 text-center text-white shadow-xl">
               <p className="text-[#88b5b9] text-[12px] font-bold uppercase tracking-widest m-0 mb-2">Available Balance</p>
               <h1 className="text-[40px] font-black m-0 mb-6 text-[#1db954]">₹{(userData.wallet_balance || 0).toLocaleString()}</h1>
               
               <div className="bg-white/10 p-5 rounded-2xl border border-white/20">
                 <p className="text-sm font-bold uppercase tracking-wide m-0 mb-4">Quick Recharge</p>
                 <div className="relative mb-4">
                   <span className="absolute left-4 top-1/2 -translate-y-1/2 text-[#002f34] font-black text-lg">₹</span>
                   <input type="number" placeholder="Amount" value={rechargeAmount} onChange={(e) => setRechargeAmount(e.target.value)} className="w-full py-3 pl-10 pr-4 rounded-xl border-none font-bold text-lg text-[#002f34] outline-none" />
                 </div>
                 <div className="flex gap-2 flex-wrap justify-center mb-5">
                   {[500, 1000, 5000].map(amt => (
                     <button key={amt} onClick={() => setRechargeAmount(amt.toString())} className="px-3 py-1.5 rounded-lg bg-transparent border border-white/30 text-white text-[11px] font-bold cursor-pointer hover:bg-white/20">+₹{amt}</button>
                   ))}
                 </div>
                 <button disabled={isRecharging} onClick={handleWalletRecharge} className={`w-full py-3 rounded-xl font-black uppercase text-sm border-none cursor-pointer ${isRecharging ? 'bg-gray-400' : 'bg-[#ef5e33] shadow-[0_5px_15px_rgba(239,94,51,0.4)] hover:bg-[#d94f29]'}`}>{isRecharging ? 'Processing...' : 'Proceed to Pay'}</button>
               </div>
             </div>
           )}

           {/* 5. PROFILE UPDATE */}
           {activeTab === 'Profile Update' && (
             <form onSubmit={handleProfileUpdate} className="bg-white p-5 rounded-3xl shadow-sm border border-gray-100 flex flex-col gap-4">
               <div>
                 <label className="text-[10px] font-black text-gray-400 uppercase">Profile Picture</label>
                 <input type="file" accept="image/*" onChange={(e) => setProfileImage(e.target.files[0])} style={inputStyle} className="mt-1" />
               </div>
               <div>
                 <label className="text-[10px] font-black text-gray-400 uppercase">Full Name</label>
                 <input type="text" value={profileData.name} onChange={(e) => setProfileData({...profileData, name: e.target.value})} style={inputStyle} className="mt-1" />
               </div>
               <div>
                 <label className="text-[10px] font-black text-gray-400 uppercase">Phone Number</label>
                 <input type="text" maxLength="10" value={profileData.phone} onChange={(e) => setProfileData({...profileData, phone: e.target.value.replace(/\D/g, '')})} style={inputStyle} className="mt-1" />
               </div>
               <div>
                 <label className="text-[10px] font-black text-gray-400 uppercase">City</label>
                 <select value={profileData.city} onChange={(e) => setProfileData({...profileData, city: e.target.value})} style={inputStyle} className="mt-1">
                   <option value="">Select City</option>
                   {CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                 </select>
               </div>
               <button type="submit" className="w-full py-3 bg-[#012b72] text-white border-none rounded-xl font-black uppercase mt-2 shadow-md cursor-pointer hover:bg-[#011f54]">Save Changes</button>
             </form>
           )}

           {/* 6. MY ADDRESS */}
           {activeTab === 'My Address' && (
             <form onSubmit={handleAddressUpdate} className="bg-white p-5 rounded-3xl shadow-sm border border-gray-100 flex flex-col gap-4">
               <div className="bg-[#fff4e6] p-3 rounded-xl border-l-4 border-[#ef5e33] text-[11px] text-[#ef5e33] font-bold">💡 Address is used for car delivery.</div>
               <div>
                 <label className="text-[10px] font-black text-gray-400 uppercase">Street Address</label>
                 <input type="text" value={addressData.address_line} onChange={(e) => setAddressData({...addressData, address_line: e.target.value})} style={inputStyle} className="mt-1" required />
               </div>
               <div>
                 <label className="text-[10px] font-black text-gray-400 uppercase">Landmark</label>
                 <input type="text" value={addressData.landmark} onChange={(e) => setAddressData({...addressData, landmark: e.target.value})} style={inputStyle} className="mt-1" />
               </div>
               <div className="flex gap-3">
                 <div className="flex-1">
                   <label className="text-[10px] font-black text-gray-400 uppercase">State</label>
                   <select value={addressData.state} onChange={(e) => setAddressData({...addressData, state: e.target.value})} style={inputStyle} className="mt-1" required>
                     <option value="">State</option>{STATES.map(s => <option key={s} value={s}>{s}</option>)}
                   </select>
                 </div>
                 <div className="flex-1">
                   <label className="text-[10px] font-black text-gray-400 uppercase">City</label>
                   <select value={addressData.city} onChange={(e) => setAddressData({...addressData, city: e.target.value})} style={inputStyle} className="mt-1" required>
                     <option value="">City</option>{CITIES.map(c => <option key={c} value={c}>{c}</option>)}
                   </select>
                 </div>
               </div>
               <div>
                 <label className="text-[10px] font-black text-gray-400 uppercase">PIN Code</label>
                 <input type="text" maxLength="6" value={addressData.pin_code} onChange={(e) => setAddressData({...addressData, pin_code: e.target.value.replace(/\D/g, '')})} style={inputStyle} className="mt-1" required />
               </div>
               <button type="submit" className="w-full py-3 bg-[#ef5e33] text-white border-none rounded-xl font-black uppercase mt-2 shadow-md cursor-pointer hover:bg-[#d94f29]">Save Address</button>
             </form>
           )}

           {/* 7. ANALYTICS */}
           {activeTab === 'Analytics' && (
             <div className="grid grid-cols-2 gap-3">
               <div className="bg-white p-5 rounded-2xl text-center shadow-sm border border-gray-100"><h1 className="text-3xl text-[#012b72] m-0 font-black">{myBookings.length}</h1><p className="text-[10px] font-black text-gray-400 uppercase m-0 mt-1">Bookings</p></div>
               <div className="bg-white p-5 rounded-2xl text-center shadow-sm border border-gray-100"><h1 className="text-3xl text-[#1db954] m-0 font-black">{myOrders.length}</h1><p className="text-[10px] font-black text-gray-400 uppercase m-0 mt-1">Orders</p></div>
             </div>
           )}

        </div>
      </div>
    );
  }

  // ==========================================
  // 🚨 MAIN ACCOUNT MENU VIEW 🚨
  // ==========================================
  return (
    <div className="min-h-screen bg-[#f4f7f6] flex flex-col font-sans selection:bg-transparent pb-[80px]">
      
      <div className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#012b72] shadow-md py-3' : 'bg-[#012b72] pt-4 pb-6 shadow-none rounded-b-[1.5rem]'}`}>
        <div className="px-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <div className="w-[45px] h-[45px] rounded-full bg-[#1db954] flex items-center justify-center text-lg font-black shadow-sm border-2 border-white/20 shrink-0 overflow-hidden">
                {userData?.avatar ? (
                   <img src={`https://bahcarplaza.com/api/files/${userData.collectionId}/${userData.id}/${userData.avatar}`} className="w-full h-full object-cover" alt="Profile" />
                ) : ( <span className="text-white">{getInitials(userData?.name)}</span> )}
              </div>
              <div className="flex flex-col justify-center">
                <span className="text-[10px] font-black text-blue-300 uppercase tracking-widest mb-0.5 transition-opacity duration-300">Welcome back</span>
                <h2 className={`m-0 text-white font-black leading-tight truncate tracking-wide transition-all duration-300 ${isScrolled ? 'text-[16px]' : 'text-[18px]'}`}>
                  {userData?.name || 'User'}
                </h2>
              </div>
            </div>
            
            <div className={`transition-opacity duration-300 ${isScrolled ? 'opacity-0' : 'opacity-100'}`}>
              <button onClick={goBack} className="bg-white/10 border border-white/20 p-2 rounded-full flex items-center justify-center cursor-pointer hover:bg-white/20 transition-colors">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={`transition-all duration-300 ${isScrolled ? 'h-[65px]' : 'h-[105px]'}`}></div>

      <div className="px-4 -mt-4 relative z-40 mb-4">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 flex justify-between items-center">
           <div>
             <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest m-0 mb-1">Registered Phone</p>
             <p className="m-0 text-[#002f34] text-[14px] font-black">+91 {userData?.phone || 'N/A'}</p>
           </div>
           <div className="bg-[#e1f9eb] text-[#1db954] px-3 py-1.5 rounded-lg text-[10px] font-black uppercase">Verified ✓</div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto pb-4 hide-scrollbar flex flex-col gap-0.5 px-4">
        <div className="flex flex-col gap-0.5 bg-white rounded-2xl p-2 shadow-sm border border-gray-100">
          {MENU_ITEMS.map((item, index) => (
            <div
              key={index}
              onClick={() => handleMenuClick(item.name)}
              className={`flex items-center justify-between py-3 px-3 rounded-xl cursor-pointer transition-colors active:scale-[0.98] ${index !== MENU_ITEMS.length -1 ? 'border-b border-gray-50' : ''}`}
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-[#f4f7f6] flex items-center justify-center text-[18px]">
                  {item.icon}
                </div>
                <span className="font-bold text-[#002f34] text-[14px]">{item.name}</span>
              </div>
              
              <div className="flex items-center gap-3">
                {item.badge && (
                  <span className={`text-[9px] font-black px-2.5 py-1.5 rounded-md uppercase tracking-wider ${item.badgeColor}`}>
                    {item.badge}
                  </span>
                )}
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 flex flex-col gap-3">
          {isAdmin && (
            <div 
              onClick={() => setView('mobile_admin')} 
              className="flex items-center justify-between p-4 rounded-2xl cursor-pointer bg-gradient-to-r from-[#012b72] to-[#001740] active:scale-95 transition-transform shadow-md"
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center text-[18px] text-white">
                  🛡️
                </div>
                <span className="font-black text-white text-[14px] uppercase tracking-wide">Admin Panel</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          )}

          <div className="flex flex-col gap-2">
            <button onClick={handleLogout} className="flex items-center justify-center gap-2 bg-white w-full py-4 rounded-2xl border border-red-100 shadow-sm cursor-pointer text-red-500 active:bg-red-50 transition-colors">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span className="font-black text-[13px] uppercase">Logout Securely</span>
            </button>

            <div className="text-center mt-2">
              <p className="m-0 text-gray-400 font-bold text-[10px]">Bah! Car Plaza App V1.0</p>
              <p className="m-0 text-gray-300 font-bold text-[9px] mt-0.5">© 2026 All Rights Reserved</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default MobileAccount;